import Vue from 'vue';
import moment from 'moment';

Vue.filter('aodocsShortner', name => name.replace(/AODocs/i, ''));
Vue.filter('applicationScope', value => value.replace(/,/g, ', '));
Vue.filter(
	'bgImg',
	imgPath => `background-image:url(${imgPath}) !important`,
	);
Vue.filter(
	'gSiteUrlShortner',
	urlPath => `...${urlPath.replace('https://sites.google.com/', '')}`,
	);
Vue.filter(
	'timeAgoFormat',
	timestamp => {
		if(moment().diff(timestamp, 'week') < 12){
			return moment(timestamp).fromNow();
		}
		return moment(timestamp).format('D MMM YYYY');
	},
	);